import React, { memo } from 'react';
import { Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import SecureImage from './SecureImage'; // Đảm bảo đường dẫn đúng đến file SecureImage bạn đã tách
import { resolveFileUrl } from './SecureFileDisplay'; // Dùng chung hàm resolve URL

// ============================================================================
// COMPONENT CHÍNH: HIỂN THỊ ẢNH ĐẠI DIỆN DÒ TÌM THÔNG MINH
// ============================================================================
const ListThumbnail = memo(({ item, fields, context, altText, sx }) => {
  
  // HÀM LOGIC INTERNAL: TỰ DÒ TÌM THUMBNAIL TỪ CÁC FIELD FILE
  const findImageUrl = (itemData, fieldsList, ctx) => {
    // Ưu tiên 1: Các trường ảnh mặc định được đặt tên chuẩn
    let explicitImage = itemData.picture || itemData.hinh_anh;
    if (explicitImage) return resolveFileUrl(explicitImage, true, ctx);

    // Ưu tiên 2: Càn quét tất cả các trường cấu hình là File / FileArray
    if (fieldsList && Array.isArray(fieldsList)) {
      for (const f of fieldsList) {
        if (f.type === 'File' || f.type === 'FileArray' || f.type === 'image') {
          const val = itemData[f.field];
          if (!val) continue;

          // Lấy file đầu tiên trong mảng hoặc chính nó
          let firstFile = Array.isArray(val) ? val[0] : val;
          if (firstFile) {
             // Đọc tên file để kiểm tra đuôi
             const fileName = typeof firstFile === 'object' 
                ? String(firstFile.name || firstFile.file_name || firstFile.originalname || '') 
                : String(firstFile);
             
             // Kiểm tra xem đuôi file có phải định dạng ảnh phổ biến không
             const isImage = /\.(jpe?g|png|gif|webp)$/i.test(fileName);
             
             // Nếu là ảnh, hoặc dữ liệu chỉ là chuỗi ID cộc lốc (không có chấm đuôi file)
             // thì ta "đánh cược" lấy làm ảnh đại diện.
             if (isImage || (typeof firstFile === 'string' && !firstFile.includes('.'))) {
               return resolveFileUrl(firstFile, true, ctx);
             }
          }
        }
      }
    }
    return null;
  };

  // Thực hiện dò tìm ảnh
  const imageUrl = findImageUrl(item, fields, context);
  return (
    <Box sx={{ 
      width: 48, height: 48, borderRadius: 2, overflow: 'hidden', flexShrink: 0, 
      bgcolor: '#f2f2f7', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e5ea',
      position: 'relative', flexShrink: 0, ...sx
    }}>
      {imageUrl ? (
        <SecureImage
          alt={altText || "Image"}
          src={imageUrl}
          // Sử dụng objectFit cover để ảnh luôn lấp đầy khung 48x48
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          // Bắt lỗi nếu link ảnh die -> Ẩn thẻ img đi để icon nềnImageIcon hiện lên thay thế
          onError={(e) => { e.target.style.display = 'none'; }} 
        />
      ) : (
        // Icon mặc định nếu không dò được ảnh nào
        <ImageIcon sx={{ color: '#8e8e93', fontSize: 20 }} />
      )}
    </Box>
  );
});

export default ListThumbnail;